import React, {useRef, useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {useAuth} from '../../../contexts/AuthContext';

const styles = {
  paper: {
    marginTop: '128px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  error: {
    color: 'red'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: '8px',
  },
  submit: {
    margin: 'auto',
    marginTop: '16px',
  }
};

export default function Login() {
  const { login, currentUser } = useAuth();
  const [error, setError] = useState();
  const emailRef = useRef();
  const passwordRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if(currentUser){
      navigate('/')
    }
  }, [currentUser, navigate]);

  const handleSubmit = (e) => {
    setError('');
    e.preventDefault();
      login(emailRef.current.value, passwordRef.current.value).then(()=>{
      navigate("/");
    }, (error) => {
      setError(error.message);
    });
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div style={styles.paper}>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form style={styles.form} onSubmit={handleSubmit} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            inputRef={emailRef}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            inputRef={passwordRef}
          />
          { error && 
          <Typography style={styles.error} component="h5">
            {error}
          </Typography>
          }
          
          {/* <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          /> */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            style={styles.submit}
          >
            Sign In
          </Button>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mt: 2 }}>
            <Link href="/forgotpassword" variant="body2">
              Forgot password?
            </Link>
            <Link href="/signup" variant="body2">
              {"Don't have an account? Sign Up"}
            </Link>
          </Box>
        </form>
      </div>
    </Container>
  );
}